import { Card } from 'nhsuk-react-components';

export interface CommsUpdate {
  name: string;
  old: string;
  new: string;
}

interface RoutingPlanUpdatesCardProps {
    title: string;
    type: string;
    updates: CommsUpdate[];
}

function RoutingPlanUpdatesCard({ title, type, updates }: RoutingPlanUpdatesCardProps) {
  return (
    <Card cardType="non-urgent">
      <Card.Heading>
        <p className="nhsuk-u-margin-bottom-0">{title}</p>
      </Card.Heading>
      <div className="nhsuk-u-padding-bottom-1">
        {updates.sort((a, b) => a.name.localeCompare(b.name)).map((item, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={idx}>
            <p className="nhsuk-u-margin-top-2 nhsuk-u-margin-bottom-1">
              {type}
              :
              {' '}
              <strong>{item.name}</strong>
            </p>
            <p className="nhsuk-u-margin-bottom-0">
              <strong>Old:</strong>
              {' '}
              {item.old}
            </p>
            <p className="nhsuk-u-margin-bottom-0">
              {' '}
              <strong>New:</strong>
              {' '}
              {item.new}
            </p>
            {idx !== updates.length - 1 && <div className="row-border nhsuk-u-padding-bottom-0 nhsuk-u-margin-left-0" />}
          </div>
        ))}
      </div>
    </Card>
  );
}

export default RoutingPlanUpdatesCard;
